import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconMail,
  IconMapPin,
  IconPhone,
} from "@tabler/icons-react";
import { useLocaleContext } from "src/context/locale-context";
import classes from "./TopContactBar.module.css";

// Social links have no CMS field yet, so they stay a small per-tenant map (missing entry = none
// shown for that tenant). Addresses, phone and email now come from the CMS via getStringRes
// (see i18n-keys-to-add.json), same as any other site text, so every tenant can fill them in
// without a code change.
const TENANT_SOCIAL_INFO = {
  celotleti: {
    facebookUrl: "https://www.facebook.com/celotleti.lv",
    instagramUrl: "https://www.instagram.com/celotleti.lv",
  },
};

function SocialIcon({ href, children }) {
  if (!href) return <span className={classes.social}>{children}</span>;
  return (
    <a href={href} target="_blank" rel="noreferrer" className={classes.social}>
      {children}
    </a>
  );
}

export function TopContactBar() {
  const { getStringRes } = useLocaleContext();
  const tenant = window.SERVER_DATA?.REACT_APP_TENANT_NAME;
  const social = TENANT_SOCIAL_INFO[tenant] || {};

  const address1 = getStringRes("topbar.address1");
  // A second address line is optional — don't show it as a raw untranslated key for tenants
  // that only ever fill in the first one.
  const address2 = getStringRes("topbar.address2");
  const hasAddress2 = address2 !== "topbar.address2";
  const phone = getStringRes("topbar.phone");
  // Optional, same as address2 — don't show a raw untranslated key for tenants without one.
  const email = getStringRes("topbar.email");
  const hasEmail = email !== "topbar.email";

  return (
    <div className={classes.bar}>
      <div className={classes.inner}>
        <div className={classes.left}>
          <span className={classes.item}>
            <IconMapPin size={14} stroke={1.75} />
            {address1}
          </span>
          {hasAddress2 && (
            <span className={classes.item}>
              <IconMapPin size={14} stroke={1.75} />
              {address2}
            </span>
          )}
        </div>
        <div className={classes.right}>
          <a href={`tel:${phone.replace(/\s+/g, "")}`} className={classes.item}>
            <IconPhone size={14} stroke={1.75} />
            {phone}
          </a>
          {hasEmail && (
            <a href={`mailto:${email}`} className={classes.item}>
              <IconMail size={14} stroke={1.75} />
              {email}
            </a>
          )}
          <span className={`${classes.socialGroup} ${classes.desktopOnly}`}>
            <SocialIcon href={social.facebookUrl}>
              <IconBrandFacebook size={16} stroke={1.75} />
            </SocialIcon>
            <SocialIcon href={social.instagramUrl}>
              <IconBrandInstagram size={16} stroke={1.75} />
            </SocialIcon>
          </span>
        </div>
      </div>
    </div>
  );
}
